"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = textFormatToContentType;
function textFormatToContentType(textFormat) {
  switch (textFormat) {
    case 'plain':
      return 'text/plain';
    case 'xml':
      return 'text/xml';
    default:
      return 'text/markdown';
  }
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ0ZXh0Rm9ybWF0VG9Db250ZW50VHlwZSIsInRleHRGb3JtYXQiXSwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9VdGlscy90ZXh0Rm9ybWF0VG9Db250ZW50VHlwZS5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCBmdW5jdGlvbiB0ZXh0Rm9ybWF0VG9Db250ZW50VHlwZSh0ZXh0Rm9ybWF0KSB7XG4gIHN3aXRjaCAodGV4dEZvcm1hdCkge1xuICAgIGNhc2UgJ3BsYWluJzpcbiAgICAgIHJldHVybiAndGV4dC9wbGFpbic7XG5cbiAgICBjYXNlICd4bWwnOlxuICAgICAgcmV0dXJuICd0ZXh0L3htbCc7XG5cbiAgICBkZWZhdWx0OlxuICAgICAgcmV0dXJuICd0ZXh0L21hcmtkb3duJztcbiAgfVxufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBZSxTQUFTQSx1QkFBdUJBLENBQUNDLFVBQVUsRUFBRTtFQUMxRCxRQUFRQSxVQUFVO0lBQ2hCLEtBQUssT0FBTztNQUNWLE9BQU8sWUFBWTtJQUVyQixLQUFLLEtBQUs7TUFDUixPQUFPLFVBQVU7SUFFbkI7TUFDRSxPQUFPLGVBQWU7RUFDMUI7QUFDRiJ9